// The existing "de" resource and selector contain the Dutch translations.
export const normalizeLanguage = value => {
  if (typeof value !== 'string') return null;

  const language = value.trim().toLowerCase().split(/[-_]/)[0];
  if (language === 'nl') return 'de';
  return ['en', 'it', 'fr', 'de'].includes(language) ? language : null;
};

export const parseSettings = value => {
  try {
    const settings = typeof value === 'string' ? JSON.parse(value) : value;
    return settings && typeof settings === 'object' && !Array.isArray(settings)
      ? settings
      : null;
  } catch (err) {
    return null;
  }
};

export const readStoredSettings = () => {
  try {
    return parseSettings(window.localStorage.getItem('settings'));
  } catch (err) {
    return null;
  }
};

export const getInitialLanguage = () => {
  const settings = readStoredSettings();
  try {
    return normalizeLanguage(settings && settings.language)
      || normalizeLanguage(window.localStorage.getItem('i18nextLng'))
      || 'en';
  } catch (err) {
    return 'en';
  }
};
